<mat-card appearance="outlined" class="default-card">
    <mat-card-header>
        <mat-card-title>Suppression de commentaire</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="container">
            <p class="text">ATTENTION! Vous êtes sur le point de supprimer le commentaire du {{ data.date }} dont le texte commence par '{{ data.text.substring(0, 25) }}...'.</p>
            <p class="text">Confirmez-vous la suppression de ce commentaire ?</p>
        </div>
    </mat-card-content>
    <mat-card-actions>
        <button mat-stroked-button class="accent-button" [mat-dialog-close]="false">Annuler</button>
        <button mat-raised-button class="accent-button" [mat-dialog-close]="true">Valider</button>
    </mat-card-actions>
</mat-card>
